/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_View_CalendarInputs */



/**
* | output |
* | --- |
* | "Week" |
*
* @param {Settings_View_CalendarInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_view_calendar = /** @type {((inputs?: Settings_View_CalendarInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_View_CalendarInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Semaine")
	return /** @type {LocalizedString} */ ("Week")
});